if (!customElements.get('region-compressor-details')) {
  customElements.define('region-compressor-details', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.configs = JSON.parse(this.querySelector('[data-compressor-data]').textContent);
      this.bySku = new Map(this.configs.map(config => [config.sku, config]));
      this.byOption = new Map(this.configs.map(config => [config.option_value, config]));
      this.populateConfigOptions();
      this.tabs = [...this.querySelectorAll('[data-compressor-tab]')];
      this.addEventListener('click', event => {
        const target = event.target.closest('[data-compressor-tab],[data-compressor-open]');
        if (!target) return;
        event.preventDefault();
        this.openTab(target.dataset.compressorTab || target.dataset.compressorOpen);
        if (target.hasAttribute('data-compressor-open')) this.querySelector('.region-compressor-details__details').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      }, options);
      this.querySelector('[role="tablist"]').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        const current = this.tabs.indexOf(event.target);
        if (current < 0) return;
        event.preventDefault();
        const index = event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length-1 : (current + (event.key==='ArrowRight'?1:-1) + this.tabs.length) % this.tabs.length;
        this.openTab(this.tabs[index].dataset.compressorTab);
        this.tabs[index].focus();
      }, options);
      this.querySelector('[data-compressor-config]')?.addEventListener('change', event => {
        const config = this.bySku.get(event.target.value);
        const picker = this.getPicker();
        if (config && picker && [...picker.options].some(option => option.value === config.option_value)) {
          picker.value = config.option_value;
          picker.dispatchEvent(new Event('change', {bubbles:true}));
          this.update(config.sku);
        } else {
          event.target.value = this.dataset.selectedSku;
        }
      }, options);
      document.addEventListener('change', event => {
        if (event.target === this.getPicker()) {
          const config = this.byOption.get(event.target.value);
          if (config) this.update(config.sku);
        }
        if (event.target.matches('.region-product-header input[name="id"]')) {
          const config = this.configs.find(item => item.variant_id === event.target.value);
          if (config) this.update(config.sku);
        }
      }, options);
      document.addEventListener('shopify:section:load', () => this.observeHeader(), options);
      this.update(this.dataset.selectedSku);
      this.observeHeader();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
    populateConfigOptions() {
      const picker = this.querySelector('[data-compressor-config]');
      if (!picker) return;
      const fragment = document.createDocumentFragment();
      const groups = new Map();
      this.configs.forEach(config => {
        if (!groups.has(config.model)) {
          const group = document.createElement('optgroup');
          group.label = config.model;
          groups.set(config.model, group);
          fragment.append(group);
        }
        const option = document.createElement('option');
        option.value = config.sku;
        option.textContent = config.label + ' — ' + config.sku;
        option.selected = config.sku === this.dataset.selectedSku;
        groups.get(config.model).append(option);
      });
      picker.replaceChildren(fragment);
    }
    getPicker() {
      return [...document.querySelectorAll('.region-product-header variant-selects select')].find(picker => [...picker.options].some(option => this.byOption.has(option.value)));
    }
    observeHeader() {
      this.observer?.disconnect();
      const header = this.getPicker()?.closest('.region-product-header');
      if (header) {
        this.observer = new MutationObserver(() => this.syncHeader());
        this.observer.observe(header, {childList:true,subtree:true});
      }
      this.syncHeader();
    }
    syncHeader() {
      const picker = this.getPicker();
      if (!picker) return;
      [...picker.options].forEach(option => {
        const config = this.byOption.get(option.value);
        if (config) {
          const label = config.label + ' — ' + config.sku;
          if (option.textContent.trim() !== label) option.textContent = label;
        }
      });
      const config = this.byOption.get(picker.value);
      if (config && config.sku !== this.dataset.selectedSku) this.update(config.sku);
    }
    openTab(name) {
      if (!this.tabs.some(tab => tab.dataset.compressorTab === name)) return;
      this.tabs.forEach(tab => {
        const active = tab.dataset.compressorTab === name;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.querySelectorAll('[data-compressor-panel]').forEach(panel => panel.hidden = panel.dataset.compressorPanel !== name);
    }
    update(sku) {
      const config = this.bySku.get(sku);
      if (!config) return;
      this.dataset.selectedSku = sku;
      const headerSku = this.getPicker()?.closest('.region-product-header')?.querySelector('[id^="ProductSku-"]');
      if (headerSku) headerSku.textContent = sku;
      const picker = this.querySelector('[data-compressor-config]');
      if (picker) picker.value = sku;
      this.querySelectorAll('[data-compressor-model]').forEach(node => node.textContent = config.model);
      this.querySelectorAll('[data-compressor-sku]').forEach(node => node.textContent = sku);
      this.querySelectorAll('[data-compressor-label]').forEach(node => node.textContent = config.detail_label);
      this.querySelectorAll('[data-compressor-field]').forEach(node => node.textContent = config[node.dataset.compressorField] || '');
      this.querySelectorAll('[data-compressor-spec]').forEach(node => {
        const value = config.specs[node.dataset.compressorSpec] || '';
        node.textContent = value;
        node.closest('[data-compressor-spec-row]').hidden = !value;
      });
      this.querySelector('[data-compressor-includes]')?.replaceChildren(...config.includes.map(text => {
        const item = document.createElement('li'); item.textContent = text; return item;
      }));
    }
  });
}
